import { button, column, row } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { ProductFormPublicTypeEnum } from 'site/graphql';

type IPrivateProductDetailFilterProps = {
    forms: ProductFormPublicTypeEnum[];
    changeFilter: (formType: ProductFormPublicTypeEnum | 'DEFAULT') => void;
    displayWebinarButton: boolean;
    displaySeminarButton: boolean;
} & WithStyles<typeof styles>;

class PrivateProductDetailFilter extends React.PureComponent<IPrivateProductDetailFilterProps> {
    filterFormItems = (formType: ProductFormPublicTypeEnum | 'DEFAULT') => this.props.changeFilter(formType);

    createButton = (formType: ProductFormPublicTypeEnum) => {
        const { classes, displayWebinarButton, displaySeminarButton } = this.props;
        let text: string;

        switch (formType) {
            case ProductFormPublicTypeEnum.Webinar:
                if (displayWebinarButton) {
                    text = 'Онлайн занятия';
                    break;
                } else {
                    return null;
                }
            case ProductFormPublicTypeEnum.Seminar:
                if (displaySeminarButton) {
                    text = 'Семинары';
                    break;
                } else {
                    return null;
                }
            case ProductFormPublicTypeEnum.VideoCourse:
                text = 'Видеокурс';
                break;
            case ProductFormPublicTypeEnum.EventRecord:
                text = 'Видеозаписи';
                break;
            case ProductFormPublicTypeEnum.Material:
                text = 'Материалы';
                break;
            case ProductFormPublicTypeEnum.Certificate:
                text = 'Сертификаты';
                break;
            default:
                return null;
        }

        return (
            <div className={classes.item} key={formType}>
                <button className={classes.button} onClick={() => this.filterFormItems(formType)}>
                    <p className={classes.text}>{text}</p>
                </button>
            </div>
        );
    };

    render() {
        const { classes, forms } = this.props;
        const buttons = Array.from(new Set(forms)).map(form => this.createButton(form));

        return (
            forms &&
            forms.length && (
                <div className={classes.wrapper}>
                    <div className={classes.item}>
                        <button className={classes.button} onClick={() => this.filterFormItems('DEFAULT')}>
                            <p className={classes.text}>Все</p>
                        </button>
                    </div>
                    {buttons}
                </div>
            )
        );
    }
}

const styles = (theme: ITheme) =>
    createStyles({
        wrapper: {
            ...row(),
            marginTop: '1.5rem',
            marginBottom: '-1.75rem',
        },
        item: {
            ...column({ cols: 6 }),

            [theme.breakpoints.up('sm')]: {
                ...column({ cols: 4 }),
            },

            [theme.breakpoints.up('md')]: {
                ...column({ cols: 2 }),
            },
        },
        button: {
            marginBottom: '1.5rem',
            backgroundColor: 'white',
            width: '100%',
            ...button(theme),
            padding: '16px 0',
            border: `1px solid ${theme.colors.contrastBgMedium}`,
            display: 'block',
            fontWeight: 'bold',
            transition: 'background-color 0.25s ease-out, color 0.25s ease-out',

            '&:hover': {
                borderColor: '#CCCCCC',
            },

            [theme.breakpoints.down('xs')]: {
                padding: 10,
            },
        },
        text: {
            fontSize: 0.9 + 'rem',
            margin: '0 0 0 0',
        },
    });

export default injectSheet(styles, 'PrivateProductDetailFilter')(PrivateProductDetailFilter);
